import { IUsedBonusCode } from "@interfaces/user/bonusCodes";
import { createContext, useContext } from "react";

const BonusLogContext = createContext<IUsedBonusCode>(undefined as any);
export const BonusLogProvider = BonusLogContext.Provider;

export function useBonusLogContext(): IUsedBonusCode | undefined {
    return useContext(BonusLogContext);
}